var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"query-keys"},[(_vm.data && _vm.data.length > 0)?[_c('p',{staticClass:"query-keys__text"},[_vm._v("抱歉，未找到相关内容，你是不是想找：")]),_c('div',{staticClass:"recommend-query"},[_c('div',{staticClass:"recommend-query__content"},_vm._l((_vm.data),function(item,index){return _c('router-link',{key:index,staticClass:"recommend-query__link",attrs:{"to":{ name: 'search', query: { keyword: item } }},nativeOn:{"click":function($event){return _vm.handlePushLog(
              'xeslog-noCourserecommendQuery-search',
              item,
              index,
              '1.4.28',
              $event
            )}}},[_vm._v(_vm._s(item))])}),1)])]:[_c('p',{staticClass:"query-keys__text"},[_vm._v("抱歉，未找到相关课程")])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce2123e0","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SearchPage/components/QueryKeys.vue
// module id = 1260
// module chunks = 1